import React from 'react'
import { useExportMobilNorthChinaTripPoint, useGetMobilNorthChinaTripPoints } from '../../api/point'
import { PointPanelScreen } from '../shared/PointPanelScreen'
import { LUBRICANT } from '../../constant/htg-companies'

export const MobilNorthChinaTripPoints = () => {
  const columns = [
    { id: 'companyAccountId', label: 'Company Id' },
    { id: 'companyName', label: 'Company Name' },
    { id: 'point', label: 'Total Points' },
    { id: 'salesId', label: 'Sales Id' },
  ]

  return (
    <PointPanelScreen
      title='Mobil North China Trip Point'
      htgCompany={LUBRICANT}
      useExportApi={useExportMobilNorthChinaTripPoint}
      useGetPoints={useGetMobilNorthChinaTripPoints}
      columns={columns}
      linkBase='mobil-north-china-trip-summary'
    />
  )
}
